import { render } from "./Tabs.vue?vue&type=template&id=191ddb74&scoped=true&lang=pug"
import script from "./Tabs.vue?vue&type=script&lang=ts"
export * from "./Tabs.vue?vue&type=script&lang=ts"

import "./Tabs.vue?vue&type=style&index=0&id=191ddb74&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-191ddb74"

export default script